import React from 'react';

function CloseXIcon(props) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M19.4,3.4c0.8-0.8,0.8-2,0-2.8c-0.8-0.8-2-0.8-2.8,0L10,7.2L3.4,0.6c-0.8-0.8-2-0.8-2.8,0s-0.8,2,0,2.8L7.2,10l-6.6,6.6c-0.8,0.8-0.8,2,0,2.8s2,0.8,2.8,0l6.6-6.6l6.6,6.6c0.8,0.8,2,0.8,2.8,0c0.8-0.8,0.8-2,0-2.8L12.8,10L19.4,3.4z"/>
    </svg>
  );
}

export default CloseXIcon;
